export default __webpack_public_path__ + "static/media/eth-black.ff577322.svg";